import type { Tool } from "@carbon-os/server/contract";

/** The filter only earns its space once the grid no longer fits at a glance. */
export const FILTER_THRESHOLD = 8;

/** Case- and accent-insensitive, so "gestao" finds "Gestão". */
function fold(text: string): string {
  return text.normalize("NFD").replace(/\p{M}/gu, "").toLowerCase();
}

export function filterTools(tools: Tool[], query: string): Tool[] {
  const needle = fold(query.trim());
  if (!needle) return tools;
  return tools.filter((tool) => fold(tool.name).includes(needle));
}

/** A second check before anything becomes an href; the server already checked once. */
export function isHttpUrl(url: string | null): url is string {
  if (!url) return false;
  try {
    const { protocol } = new URL(url);
    return protocol === "http:" || protocol === "https:";
  } catch {
    return false;
  }
}

/** carbon-os's own copy of the tool's Gatekeeper logo. A 404 means none: the card shows initials. */
export function toolLogoUrl(key: string): string {
  return `/api/tools/${encodeURIComponent(key)}/logo`;
}

/** The line under a tool's name. Never the raw `kind`. */
export function toolHint(tool: Tool): string {
  // No link wins: a card that cannot be opened must not promise a sign-in.
  if (!isHttpUrl(tool.url)) return "No link on file";
  if (tool.kind === "carbonos") return "Signs in with your Carbon account";
  return new URL(tool.url).hostname.replace(/^www\./, "");
}
